import { AvatarComponent } from "./avatar";

export const AppAvatar = AvatarComponent;
